import { Link } from "react-router-dom";
import { useSeo } from "../components/site/Layout";
import { PageHero, Section, CtaBand } from "../components/site/blocks";

export default function NotFound() {
  useSeo("Page introuvable", "Cette page n'existe pas.");
  return (
    <>
      <PageHero eyebrow="Erreur 404" title="Cette page est introuvable" intro="Le lien que vous avez suivi est peut-être ancien ou erroné." testid="not-found">
        <Link to="/" className="btn-primary">Retour à l'accueil</Link>
        <Link to="/contact" className="btn-outline">Nous écrire</Link>
      </PageHero>
      <Section><p className="text-slate-700">Vous pouvez utiliser le menu pour retrouver nos services, nos guides et nos formulaires de contact.</p></Section>
      <CtaBand />
    </>
  );
}
